// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { Form, FormProps } from 'antd';
import { Meta } from 'rc-field-form/lib/interface';
import { classList } from '@Helpers/className';
import { Item } from './Item';
import { List } from './List';
import { Layout } from './Layout';

import './THForm.scss';

export interface THFormProps<T> extends FormProps<T> {
    editable?: boolean;
    submitTouchedValues?: boolean | string[];
}

export const THForm = <T,>({
    children,
    editable,
    className = '',
    layout,
    colon,
    onFinish,
    form,
    submitTouchedValues = false,
    ...props
}: THFormProps<T>): ReactElement => (
    <Form<T>
        className={classList('th-form', className, { 'th-form__editable': editable })}
        layout={layout || 'vertical'}
        colon={colon || false}
        form={form}
        onFinish={(values) => {
            if (submitTouchedValues) {
                const namePaths = Array.isArray(submitTouchedValues) ? submitTouchedValues : [];
                const excludedFields: string[] = [];

                const touchedFilter = (meta: Meta): boolean => {
                    if (namePaths.length === 0) return meta.touched;
                    const fieldName = (meta.name || [''])[0] as string;
                    if (namePaths.includes(fieldName) && meta.touched && !excludedFields.includes(fieldName)) {
                        excludedFields.push(fieldName);
                    }
                    return meta.touched;
                };

                const touchedValues = form?.getFieldsValue(true, touchedFilter as any);

                if (onFinish) {
                    onFinish(
                        touchedValues
                            ? {
                                  ...touchedValues,
                                  ...(form?.getFieldsValue(excludedFields) || {}),
                              }
                            : values,
                    );
                }
            } else {
                if (onFinish) {
                    onFinish(values);
                }
            }
        }}
        {...props}
    >
        {children}
    </Form>
);

THForm.Layout = Layout;
THForm.Item = Item;
THForm.List = List;
